import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

/** What a page or table shows when there is nothing yet: a title, a line, and the next step. */
export function EmptyState({ title, children, action }: { title: string; children?: ReactNode; action?: ReactNode }) {
  return (
    <Stack spacing={1.5} sx={{ alignItems: 'flex-start', maxWidth: 560 }}>
      <Typography variant="h3" component="h2">{title}</Typography>
      {children && <Typography color="textSecondary">{children}</Typography>}
      {action}
    </Stack>
  );
}
